// extracted by mini-css-extract-plugin
module.exports = {"Card":"style_Card__3_LSy","Btn":"style_Btn__3w5Zv","Marck":"style_Marck__3lUdv","Wrapper":"style_Wrapper__vEwpy","Content":"style_Content__1oAJ5","Avatar":"style_Avatar__3uhl2"};